export const formatSingleBraceTemplate = (
  template: string,
  values: Record<string, string | number>
) =>
  Object.entries(values).reduce(
    (formatted, [key, value]) =>
      formatted.split(`{${key}}`).join(String(value)),
    template
  );
